import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import _ from 'lodash'
import { getCurrentUser } from '../AppRedux/actions/Auth'
import { getAllStates } from '../AppRedux/actions/Programs'
import {
  Programs,
  Accounts,
  ProgramScreen,
  Admin,
  CreateNewAccount,
  CsipUtility,
  Vpp,
  News,
  createVpp,
  CreateNewPrograms,
  Reports,
  Requests,
  ProgramSummaryReport,
  ProgramDetails,
  SystemsEnrollment,
  SystemAddition,
  SystemsApproval,
  Systems,
  System,
  EventDetails,
  CreateEvents,
  EventsView,
  TagsManager,
  TagForm,
  Dashboard,
  Error403,
  AddSystem,
  ViewApplication,
  DeveloperHub,
  ApiDashboard,
  CloudApi,
  Introduction,
  GettingStarted,
  NoPermission,
  OAuthGuide,
  ProductLimitations,
  ReleaseNotes,
  ForeCastGraphs,
  ForeCastGraphsDashboard,
  SiteEventViewer,
  ActiveSites,
  DailyDischargeViewer,
  ApiHitsViewer,
  SiteIdsViewer,
  SiteDailyPerformance
} from '../layouts'
import ApiUsageAndMetrics from '../layouts/DeveloperHub/ApiUsageAndMetrics'
import Error404 from '../layouts/ErrorPages/Error404'
import { Loader } from '../Components'

const SuperAdminRoute = ({ component: Component, authUser, isSuperAdmin, isViewOnly, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      !isViewOnly && isSuperAdmin ? (
        <>
          <Component {...props} />
        </>
      ) : (
        <Route component={Error404} />
      )
    }
  />
)

const AdminRoute = ({ component: Component, authUser, isAdmin, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAdmin ? (
        <>
          <Component {...props} />
        </>
      ) : (
        <Route component={Error404} />
      )
    }
  />
)

const GSMRoute = ({ component: Component, authUser, isSuperAdmin, isAdmin, currentUser, isViewOnly, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
    (isViewOnly ? (
      <Route component={Error404} />
    ) : (isSuperAdmin || (currentUser && currentUser.gsmAccess === 'true')) ? (
      <>
        <Component {...props} />
      </>
    ) : (
      <Route component={Error404} />
    ))
    }
  />
)

const ViewOnlySuperAdminRoute = ({ component: Component, authUser, isSuperAdmin, isViewOnly, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      (isSuperAdmin || isViewOnly) ? (
        <>
          <Component {...props} />
        </>
      ) : (
        <Route component={Error404} />
      )
    }
  />
)

const DeveloperHubRoute = ({ component: Component, authUser, isSuperAdmin, currentUser, isViewOnly, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      (!isViewOnly || (isSuperAdmin || (currentUser && currentUser.roles && currentUser.roles.includes('ACCOUNT_ADMIN') && currentUser.apiAccess === 'true'))) ? (
        <>
          <Component {...props} />
        </>
      ) :
        (currentUser && currentUser.roles && currentUser.roles.includes('ACCOUNT_USER') && currentUser.apiAccess === 'true') ? (
          <>
            <Route component={NoPermission} />
          </>
        ) : (
          <Route component={Error404} />
        )}
  />
)

class AppRoutes extends Component {

  componentDidMount() {
    this.props.getAllStates()
  }

  render() {
    const { authUser, currentUser, getCurrentUser, isSuperAdmin, isAdmin, isViewOnly } = this.props
    if (!currentUser) {
      getCurrentUser(authUser)
    }

    return (
      currentUser ?
        <Switch>
          <GSMRoute exact path='/programs' component={Programs} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <Route exact path='/accounts' component={Accounts} isSignedInUser />
          <GSMRoute
            exact
            path="/programs/:programs_id"
            component={ProgramScreen}
            isSignedInUser
            authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin}
          />
          <SuperAdminRoute exact path="/admin" component={Admin} authUser={authUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <SuperAdminRoute exact path="/admin/onboard-csip-utility" component={CsipUtility} authUser={authUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <SuperAdminRoute exact path="/admin/create-new-account" component={CreateNewAccount} authUser={authUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/program-request" component={CreateNewPrograms} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/program-request/:programId" component={CreateNewPrograms} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <SuperAdminRoute exact path="/admin/requests" component={Requests} authUser={authUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/reports" component={Reports} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <ViewOnlySuperAdminRoute exact path="/reports/event-viewer" component={SiteEventViewer} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <ViewOnlySuperAdminRoute exact path="/reports/active-sites" component={ActiveSites} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <ViewOnlySuperAdminRoute exact path="/reports/daily-discharge-viewer" component={DailyDischargeViewer} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <ViewOnlySuperAdminRoute exact path="/reports/api-hits-viewer" component={ApiHitsViewer} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <ViewOnlySuperAdminRoute exact path="/reports/site-ids-viewer" component={SiteIdsViewer} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <ViewOnlySuperAdminRoute exact path="/reports/site-daily-performance" component={SiteDailyPerformance} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/program-summary-report" component={ProgramSummaryReport} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/programs/:programId/systems/:siteId([0-9]+)" component={System} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute
            exact
            path="/program-details/:programs_id"
            component={ProgramDetails}
            isSignedInUser
            authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin}
          />
          <AdminRoute exact path="/programs/:programId/systems-addition" component={SystemAddition} isSignedInUser isAdmin={isAdmin} />
          <AdminRoute exact path="/programs/:programId/systems-approval" component={SystemsApproval} isSignedInUser isAdmin={isAdmin} />
          <AdminRoute exact path="/programs/:programId/systems-addition/application-form" component={AddSystem} isSignedInUser isAdmin={isAdmin} />
          <AdminRoute exact path="/programs/:programId/systems-addition/view-application/:applicationId([0-9]+)" component={ViewApplication} isSignedInUser isAdmin={isAdmin} />
          <GSMRoute exact path="/vpp" component={Vpp} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/news" component={News} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/programs/:programs_id/vpp" component={Vpp} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute
            exact
            path="/vpp/create-new-vpp"
            component={createVpp}
            isSignedInUser
            authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin}
            isViewOnly={isViewOnly}
          />
          <GSMRoute exact path="/vpp/forecast-graphs" component={ForeCastGraphs} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/vpp/:vpp" component={createVpp} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/reports" component={Reports} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute
            exact
            path="/program-summary-report"
            component={ProgramSummaryReport}
            isSignedInUser
            authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin}
          />
          <GSMRoute exact path="/programs/:programId/systems" component={Systems} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path='/programs/:programs_id/events/:event_id' component={EventDetails} authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path='/programs/:programs_id/create-new-event' component={CreateEvents} authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/programs/:programId/tags-manager" component={TagsManager} isAdmin={isAdmin} authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <AdminRoute exact path="/programs/:programId/tags-manager/create-tags" component={TagForm} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/programs/:programId/tags-manager/edit-tag" component={TagForm} isAdmin={isAdmin} authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/programs/:programs_id/vpp/create-new-vpp" component={createVpp} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} isViewOnly={isViewOnly} />
          <GSMRoute exact path="/dashboard" component={Dashboard} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/dashboard/forecast-graphs" component={ForeCastGraphsDashboard} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <GSMRoute exact path="/programs/:programs_id/vpp/:vpp" component={createVpp} isSignedInUser authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <Route exact path="/unauthorized" component={Error403} />
          <GSMRoute exact path="/programs/:programs_id/events" component={EventsView} authUser={authUser} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isAdmin={isAdmin} />
          <DeveloperHubRoute exact path="/developer" component={DeveloperHub} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/introduction" component={Introduction} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/getting-started" component={GettingStarted} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/api-credentials" component={ApiDashboard} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <DeveloperHubRoute exact path="/developer/oauth-guide" component={OAuthGuide} currentUser={currentUser} isSuperAdmin={isSuperAdmin} isViewOnly={isViewOnly} />
          <DeveloperHubRoute exact path="/developer/cloud-api" component={CloudApi} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/product-limitations" component={ProductLimitations} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/api-usage-and-metrics" component={ApiUsageAndMetrics} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <DeveloperHubRoute exact path="/developer/release-notes" component={ReleaseNotes} currentUser={currentUser} isSuperAdmin={isSuperAdmin} />
          <Route component={Error404} />
        </Switch >
        : <Loader loading={true} />
    )
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

const mapDispatchToProps = (dispatch) => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
  getAllStates: (payload) => dispatch(getAllStates(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes)
